import { render } from "./Pesquisa.vue?vue&type=template&id=6b296bbc&scoped=true"
import script from "./Pesquisa.vue?vue&type=script&lang=ts"
export * from "./Pesquisa.vue?vue&type=script&lang=ts"

import "./Pesquisa.vue?vue&type=style&index=0&id=6b296bbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b296bbc"

export default script